import { UnidadMedida } from '@/enum/unidad_medida';

export const DECIMALES_MILLAR = 3;

export const esMillar = (codigoUnidadVenta) => Number(codigoUnidadVenta) === UnidadMedida.MILLAR;

export const precisionCantidad = (codigoUnidadVenta) =>
  esMillar(codigoUnidadVenta) ? DECIMALES_MILLAR : 0;

export const redondearCantidad = (valor, precision = 0) => {
  if (valor === null || valor === undefined || valor === '') return valor;
  const n = Number(valor);
  if (!Number.isFinite(n)) return valor;
  const factor = 10 ** precision;
  return Math.round((n + Number.EPSILON) * factor) / factor;
};

export const formatearCantidadVenta = (valor) => {
  if (valor === null || valor === undefined || valor === '') return '--';
  const n = Number(valor);
  if (!Number.isFinite(n)) return '--';
  return n.toLocaleString('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: DECIMALES_MILLAR,
  });
};

export const cantidadesIguales = (a, b) =>
  redondearCantidad(Number(a) || 0, DECIMALES_MILLAR) ===
  redondearCantidad(Number(b) || 0, DECIMALES_MILLAR);

export const sumarCantidades = (valores) =>
  redondearCantidad(
    valores.reduce((acc, v) => acc + (Number(v) || 0), 0),
    DECIMALES_MILLAR,
  );

// Redondea a entero las cantidades de una lista de objetos; devuelve true si alguna cambió.
export const redondearCantidadesLista = (lista, precision = 0) => {
  let cambio = false;
  (lista || []).forEach((item) => {
    if (item?.Cantidad === null || item?.Cantidad === undefined) return;
    const nuevo = redondearCantidad(item.Cantidad, precision);
    if (nuevo !== item.Cantidad) {
      item.Cantidad = nuevo;
      cambio = true;
    }
  });
  return cambio;
};
